import {
  actions as dataFetchActions,
  actionTypes as dataFetchActionTypes,
} from '@bufferapp/async-data-fetch';
import { actions as notificationActions } from '@bufferapp/notifications/lib/reducer';
import getCtaProperties from '~/analytics-middleware/utils/CtaStrings';
import { actions as analyticsActions } from '~/analytics-middleware/actions';
import { actionTypes } from './reducer';

export default ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    next(action);

    switch (action.type) {
      case actionTypes.DRAFT_CONFIRMED_DELETE: {
        dispatch(
          dataFetchActions.fetch({
            name: 'deletePost',
            args: {
              updateId: action.updateId,
              isDraft: true,
            },
          })
        );
        break;
      }
      /*
    In Classic it's REQUESTING_DRAFT_APPROVE.
    Sends draft to queue, which means approves draft
    */
      case actionTypes.DRAFT_APPROVE:
        dispatch(
          dataFetchActions.fetch({
            name: 'approveDraft',
            args: {
              updateId: action.updateId,
              isScheduled: action.isScheduled,
            },
          })
        );
        break;
      /*
    In Classic it's REQUESTING_NEEDS_APPROVAL_UPDATE:
    Requests approval as a contributor (moves draft to awaiting approval tab if needsApproval is true,
    moves from approval tab to drafts if needsApproval false)
    */
      case actionTypes.DRAFT_NEEDS_APPROVAL:
        dispatch(
          dataFetchActions.fetch({
            name: 'changeDraftStatus',
            args: {
              updateId: action.updateId,
              needsApproval: action.needsApproval,
            },
          })
        );
        break;
      case `approveDraft_${dataFetchActionTypes.FETCH_SUCCESS}`: {
        const { isScheduled } = action.args;
        const message = isScheduled
          ? 'Done! Your draft is scheduled as a post.'
          : 'Done! This draft was added to the queue.';
        dispatch(
          notificationActions.createNotification({
            notificationType: 'success',
            message,
          })
        );
        break;
      }
      case `changeDraftStatus_${dataFetchActionTypes.FETCH_SUCCESS}`: {
        dispatch(
          notificationActions.createNotification({
            notificationType: 'success',
            message: "We've successfully moved this draft!",
          })
        );
        break;
      }
      case `approveDraft_${dataFetchActionTypes.FETCH_FAIL}`: {
        const { isScheduled } = action.args;
        const message = isScheduled
          ? 'There was an error scheduling your post!'
          : 'There was an error adding this draft to the queue!';
        dispatch(
          notificationActions.createNotification({
            notificationType: 'error',
            message: action.error || message,
          })
        );
        break;
      }
      case `changeDraftStatus_${dataFetchActionTypes.FETCH_FAIL}`:
        dispatch(
          notificationActions.createNotification({
            notificationType: 'error',
            message: 'There was an error moving this draft!',
          })
        );
        break;

      // Drafts pusher events trigger a draft counter update action
      case actionTypes.DRAFT_CREATED:
      case actionTypes.DRAFT_DELETED:
      case actionTypes.DRAFT_APPROVED:
      case actionTypes.DRAFT_MOVED: {
        if (getState().profileSidebar.selectedProfileId === action.profileId) {
          dispatch(
            dataFetchActions.fetch({
              name: 'getCounts',
              args: {
                profileId: action.profileId,
              },
            })
          );
        }
        break;
      }

      case actionTypes.OPEN_COMPOSER: {
        if (action.cta) {
          const ctaProperties = getCtaProperties(action.cta);
          dispatch(
            analyticsActions.trackEvent('Composer Opened', ctaProperties)
          );
        }
        break;
      }

      default:
        break;
    }
  };
